import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../Images/logo rashi jyotish.png';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    logout();
    navigate('/signin');
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header>
      <div className="nav-inner">
        <div className="brand">
          <div className="logo-wrap">
            <img src={logo} alt="SRJ logo" />
          </div>
          <div>
            <h1>Shree Rashi Jyotish</h1>
            <p>Vedic Astrology</p>
          </div>
          <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        <nav>
          <ul className={mobileMenuOpen ? 'mobile-visible' : 'mobile-hidden'}>
            <li>
              <Link to="/dashboard" onClick={closeMobileMenu}>
                <button className={isActive('/dashboard') ? 'active' : ''}>Home</button>
              </Link>
            </li>
            <li>
              <Link to="/shop" onClick={closeMobileMenu}>
                <button className={isActive('/shop') ? 'active' : ''}>Shop</button>
              </Link>
            </li>
            <li>
              <Link to="/events" onClick={closeMobileMenu}>
                <button className={isActive('/events') ? 'active' : ''}>Events</button>
              </Link>
            </li>
            <li>
              <Link to="/VerifyCertificate" onClick={closeMobileMenu}>
                <button className={isActive('/VerifyCertificate') ? 'active' : ''}>Verify Certificate</button>
              </Link>
            </li>
            {user && user.role === 'admin' && (
              <li>
                <Link to="/admin" onClick={closeMobileMenu}>
                  <button className={isActive('/admin') || location.pathname.startsWith('/admin') ? 'active' : ''}>
                    Admin
                  </button>
                </Link>
              </li>
            )}
            {user ? (
              <>
                <li>
                  <Link to="/profile" onClick={closeMobileMenu}>
                    <button className={isActive('/profile') ? 'active' : ''}>
                      {user.profile_picture ? (
                        <img 
                          src={user.profile_picture} 
                          alt="Profile" 
                          style={{ 
                            width: '24px', 
                            height: '24px', 
                            borderRadius: '50%', 
                            marginRight: '8px',
                            objectFit: 'cover',
                            verticalAlign: 'middle'
                          }} 
                        />
                      ) : null}
                      {user.full_name || user.username}
                    </button>
                  </Link>
                </li>
                <li>
                  <button className="book" onClick={handleLogout}>Sign Out</button>
                </li>
              </>
            ) : (
              <li>
                <Link to="/signin" onClick={closeMobileMenu}>
                  <button className="book">Sign In</button>
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
